import { useMemo, useState } from "react";
import { Phase } from "../gen/game/v1/envelope_pb";
import { useGameStore } from "../store/gameStore";
import styles from "./App.module.css";

export function DevView() {
  const store = useGameStore();
  const [roomInput, setRoomInput] = useState("");
  const [selectedCard, setSelectedCard] = useState("");
  const [phrase, setPhrase] = useState("");

  const isDealer =
    store.playerId !== "" && store.snapshot?.dealerId === store.playerId;
  const phase = store.snapshot?.phase ?? Phase.LOBBY;
  const phaseName = useMemo(() => Phase[phase] ?? String(phase), [phase]);

  return (
    <main className={styles.devShell}>
      <section className={styles.panel}>
        <header className={styles.header}>
          <div>
            <p className={styles.eyebrow}>Pumpkin Party</p>
            <h1>
              {store.mode === "screen" ? "Общий экран" : "Контроллер игрока"}
            </h1>
          </div>
          <span className={`${styles.status} ${styles[store.status]}`}>
            {store.status}
          </span>
        </header>

        <div className={styles.segmented}>
          <button
            className={store.mode === "player" ? styles.active : ""}
            onClick={() => store.setMode("player")}
          >
            Игрок
          </button>
          <button
            className={store.mode === "screen" ? styles.active : ""}
            onClick={() => store.setMode("screen")}
          >
            Экран
          </button>
        </div>

        <label className={styles.field}>
          WS endpoint
          <input defaultValue={store.url} id="ws-url" />
        </label>

        {store.mode === "player" && (
          <label className={styles.field}>
            Имя
            <input
              value={store.playerName}
              onChange={(event) => store.setPlayerName(event.target.value)}
            />
          </label>
        )}

        <button
          className={styles.primary}
          onClick={() => {
            const url = (document.getElementById("ws-url") as HTMLInputElement)
              .value;
            store.connect(url, store.mode, store.playerName);
          }}
        >
          Подключиться
        </button>

        {store.error && <p className={styles.error}>{store.error}</p>}
      </section>

      <section className={styles.panel}>
        <div className={styles.roomLine}>
          <div>
            <p className={styles.label}>Комната</p>
            <strong>{store.roomCode || "----"}</strong>
          </div>
          <div>
            <p className={styles.label}>Фаза</p>
            <strong>{phaseName}</strong>
          </div>
        </div>

        {store.mode === "screen" ? (
          <button className={styles.primary} onClick={store.createRoom}>
            Создать комнату
          </button>
        ) : (
          <div className={styles.joinGrid}>
            <input
              value={roomInput}
              placeholder="Код"
              maxLength={6}
              onChange={(event) =>
                setRoomInput(event.target.value.toUpperCase())
              }
            />
            <button
              className={styles.primary}
              onClick={() => store.joinRoom(roomInput, store.playerName)}
            >
              Войти
            </button>
          </div>
        )}

        <div className={styles.actions}>
          <button onClick={store.startGame}>Готов / старт</button>
          <button onClick={store.loaded}>Загружен</button>
          <button onClick={store.skipTutorial}>Пропустить</button>
        </div>

        <ul className={styles.players}>
          {(store.snapshot?.players ?? []).map((player) => (
            <li key={player.playerId}>
              <span>{player.name}</span>
              <span>{player.ready ? "ready" : "wait"}</span>
            </li>
          ))}
        </ul>
      </section>

      {store.phrase && (
        <section className={styles.panel}>
          <p className={styles.label}>Фраза дилера</p>
          <h2>{store.phrase}</h2>
        </section>
      )}

      {store.mode === "player" && (
        <section className={styles.panel}>
          <p className={styles.label}>Рука</p>
          <div className={styles.cards}>
            {store.hand.map((cardId) => (
              <button
                key={cardId}
                className={
                  selectedCard === cardId ? styles.selectedCard : styles.card
                }
                onClick={() => setSelectedCard(cardId)}
              >
                {cardId}
              </button>
            ))}
          </div>

          {isDealer && (
            <label className={styles.field}>
              Фраза
              <textarea
                value={phrase}
                onChange={(event) => setPhrase(event.target.value)}
              />
            </label>
          )}

          <div className={styles.actions}>
            {isDealer ? (
              <button
                className={styles.primary}
                onClick={() => store.submitDealerTurn(selectedCard, phrase)}
              >
                Сдать фразу
              </button>
            ) : (
              <button
                className={styles.primary}
                onClick={() => store.playCard(selectedCard)}
              >
                Сыграть карту
              </button>
            )}
          </div>
        </section>
      )}

      {store.tableCards.length > 0 && (
        <section className={styles.panel}>
          <p className={styles.label}>Карты на столе</p>
          <div className={styles.cards}>
            {store.tableCards.map((cardId) => (
              <button
                key={cardId}
                className={styles.card}
                onClick={() => store.vote(cardId)}
              >
                {cardId}
              </button>
            ))}
          </div>
          {store.dealerCard && (
            <p className={styles.label}>Карта дилера: {store.dealerCard}</p>
          )}
        </section>
      )}

      <section className={styles.log}>
        {store.log.map((line, index) => (
          <span key={`${line}-${index}`}>{line}</span>
        ))}
      </section>

      {store.isPaused && store.roomCode && (
        <aside className={styles.pauseOverlay} role="status" aria-live="polite">
          <strong>Пауза</strong>
        </aside>
      )}
    </main>
  );
}
